import { assignSetting } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { OWF_SOFT_CREDIT_CHECK_FLOW_240411 } from "@faire/web-api--source/indigofair/settings/OWF_SOFT_CREDIT_CHECK_FLOW_240411";

export const assignSettingOwFSoftCreditCheckFlow = () =>
  assignSetting(OWF_SOFT_CREDIT_CHECK_FLOW_240411);
